import React from "react";

import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "react-chartjs-2";
import { Line, Bar } from "react-chartjs-2";

const grafico = (props) => {
  const _datos = props.datos;
  const _etiquetas = props.etiquetas;
  const data1 = {
    label: "Derivaciones",
    data: _datos,
    borderColor: "rgb(200, 200, 200)",
    backgroundColor: "rgba(255, 99, 132, 0.5)",
    pointBackgroundColor: "rgba(255, 99, 132, 0.5)",
    pointBorderColor: "rgb(255, 99, 132)",
  };

  const _data = {
    labels: _etiquetas,
    datasets: [data1],
  };

  const _options = {
    responsive: true,
    scales: {
      y: {
        min: 0,
        ticks: { stepSize: 1 },
        title: { display: true, text: "Cantidad" },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
    },
  };

  return <Bar options={_options} data={_data}></Bar>;
};

const GraficoPregunta = (props) => {
  //console.log(props);
  return <div>{grafico(props)}</div>;
};

export default GraficoPregunta;
